"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ServiceLocatorImpl {
    constructor() {
        this._services = {};
    }
    addService(serviceName, serviceInstance) {
        this._services[serviceName] = serviceInstance;
        this[serviceName] = this._services[serviceName];
    }
    removeService(serviceName) {
        delete this._services[serviceName];
        delete this[serviceName];
    }
    hasService(serviceName) {
        return this._services[serviceName] !== undefined && this[serviceName] !== undefined;
    }
    serviceNames() {
        return Object.keys(this._services);
    }
}
// singleton:
const instance = new ServiceLocatorImpl();
exports.default = instance;
//# sourceMappingURL=ServiceLocator.js.map